import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import AddEmployeeContainer from './AddEmployeeContainer'


const AddEmployeeRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><AddEmployeeContainer></AddEmployeeContainer></Provider>
}

AddEmployeeRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default AddEmployeeRoot
